<template>
  <table
    v-if="visits"
    class="table table-sm table-hover header-fixed"
  >
    <thead>
      <tr>
        <th class="ip-col">
          IPv4
        </th>
        <th class="check-col">
          AS
        </th>
        <th
          class="text-col"
          colspan="2"
        >
          Country
        </th>
        <th class="text-col">
          Browser
        </th>
        <th class="text-col">
          OS
        </th>
        <th class="check-col">
          Mobile
        </th>
        <th class="check-col">
          Tablet
        </th>
        <th class="check-col">
          Touch
        </th>
        <th class="check-col">
          PC
        </th>
        <th class="check-col">
          Bot
        </th>
        <th class="timestamp-col">
          Timestamp
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="visit in visits"
        :key="visit.id"
      >
        <td class="ip-col">
          {{ visit.visitor.ip }}
        </td>
        <td class="check-col">
          <i
            v-if="visit.visitor.rdns || visit.visitor.as"
            class="bi bi-check"
            :title="asDescription(visit.visitor)"
          />
        </td>
        <td class="flag-col">
          <span
            v-if="visit.visitor.cc"
            :class="`fi fi-${visit.visitor.cc.toLowerCase()} border me-1`"
          />
        </td>
        <td class="country-col">
          {{ visit.visitor.country }}
        </td>
        <td class="text-col">
          {{ visit.userAgent.browser.family }}
          <template v-if="visit.userAgent.browser.version">
            (v{{ visit.userAgent.browser.version }})
          </template>
        </td>
        <td class="text-col">
          {{ visit.userAgent.operatingSystem.family }}
          <template v-if="visit.userAgent.operatingSystem.version">
            (v{{ visit.userAgent.operatingSystem.version }})
          </template>
        </td>
        <td class="check-col">
          <i
            v-if="visit.userAgent.isMobile"
            class="bi bi-check"
          />
        </td>
        <td class="check-col">
          <i
            v-if="visit.userAgent.isTablet"
            class="bi bi-check"
          />
        </td>
        <td class="check-col">
          <i
            v-if="visit.userAgent.isTouchCapable"
            class="bi bi-check"
          />
        </td>
        <td class="check-col">
          <i
            v-if="visit.userAgent.isPc"
            class="bi bi-check"
          />
        </td>
        <td class="check-col">
          <i
            v-if="visit.userAgent.isBot"
            class="bi bi-check"
          />
        </td>
        <td class="timestamp-col">
          {{ visit.timestamp.date }} {{ visit.timestamp.time }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
  export default {
    data: () => ({visits: []}),
    computed: {
      deployAll: () => ["true", "t", "yes", "y", "on"].includes(
        process.env.VUE_APP_DEPLOY_ALL.toLowerCase()
      ),
      backendUrl: () => process.env.VUE_APP_VISUALIZER_BACKEND_URL,
      backendToken: () => process.env.VUE_APP_BACKEND_TOKEN,
      taskId() { return this.$route.params.taskId; },
    },
    async mounted() {
      const urlBase = `visitor-statistics/${this.taskId}`;
      const url = `${this.backendUrl}/${urlBase}/?token=${this.backendToken}`;
      const response = await fetch(url);
      this.visits = (await response.json()).visits.sort(
        (a, b) => {
          if (a.timestamp.date.localeCompare(b.timestamp.date)) return -1;
          if (a.timestamp.date.localeCompare(b.timestamp.date)) return 1;
          if (a.timestamp.time.localeCompare(b.timestamp.time)) return -1;
          if (a.timestamp.time.localeCompare(b.timestamp.time)) return 1;
          return 0;
        }
      );
    },
    methods: {
      asDescription: visitor => (
        `${visitor.rdns && `rDNS: ${visitor.rdns}`}\n` +
        `${visitor.as && `Autonomous System:\n`}` +
        `${visitor.as && visitor.as.domain && `- domain: ${visitor.as.domain}`}\n` +
        `${visitor.as && visitor.as.number && `- number: ${visitor.as.number}`}\n` +
        `${visitor.as && visitor.as.name && `- name: ${visitor.as.name}`}`
      )
    }
  }
</script>

<style scoped>
  .ip-col { width: 120px; }
  .text-col { width: 145px; }
  .flag-col { width: 30px; }
  .country-col { width: 115px; }
  .check-col {
    width: 65px;
    text-align: center;
  }
  .timestamp-col {
    width: 150px;
    text-align: right;
    white-space: nowrap;
  }
  /* header-fixed (app.scss) floats every cell left with display:block, so a
     row's cells no longer share a height - empty cells collapse to padding
     height while filled ones are a text line tall, and the floats stagger
     into a "staircase" (empty columns look indented). Pin every body/header
     cell to the same height so the floats line up. Timestamp is widened +
     nowrap above so it stays on one line and fits. */
  th,
  td {
    height: 2.25rem;
  }
</style>
